export enum SocialBulkActionEnum {
    EXPORT = 'EXPORT'
}

export enum SocialBulkActionSourceMethodEnum {
    SELECTION = 'SELECTION',
    SEARCH = 'SEARCH'
}

export enum SocialBulkActionSourceTypeEnum {
    THEME = 'THEME',
    AGENT = 'AGENT',
    ARCHIVE = 'ARCHIVE'
}
